import { differenceInDays, differenceInMonths } from 'date-fns';
import { getBillingDataRoot } from 'reactApp/modules/billingData/billingData.selectors';
import { createSelector } from 'reselect';

const getBillingDataSsrSubscriptions = createSelector(getBillingDataRoot, ({ webSubscriptionsSsr }) => webSubscriptionsSsr || []);

export const getLastSubscriptionForRenew = createSelector(getBillingDataSsrSubscriptions, (subscriptions) => {
    return subscriptions.find((sub) => {
        const now = Date.now();
        const periodMoreThen30Days = differenceInDays(sub.expires, sub.start) > 30;
        return !sub.autorenewal && sub.expires > now && periodMoreThen30Days && differenceInDays(sub.expires, now) <= 30;
    });
});

export const getExpiredSubscriptionForRenew = createSelector(getBillingDataSsrSubscriptions, (subscriptions) => {
    return subscriptions.find((sub) => {
        const now = Date.now();
        const oldSubscription = sub.expires < now;

        const periodMoreThen6Month = differenceInMonths(now, sub.expires) <= 6;

        return periodMoreThen6Month && oldSubscription;
    });
});
